import { baseURL } from 'settings';

import { api as apiService, ApiService } from './api';
import { PaginationProps } from 'interfaces/IPagination';
import { IPhysicalTransship } from 'interfaces/IPhysicalTransship';
import { toast } from 'react-toastify';

interface IPhysicalTransshipParams {
  page?: number;
  pageSize?: number;
  orderBy?: string;
  name?: string;
  search?: string;
  inUse?: number;
}

function toastApiError(e: unknown, fallback: string) {
  const data = e as { msg?: string };
  const msg = typeof data?.msg === 'string' && data.msg.trim() ? data.msg : fallback;
  toast.error(msg);
}

class PhysicalTransshipService {
  constructor(private readonly api: ApiService, private readonly baseURL: string) {}

  public getList = (params: IPhysicalTransshipParams): Promise<PaginationProps<IPhysicalTransship>> => {
    return this.api.get(`${this.baseURL}/v1/delivery/physical-transship-point`, { params });
  };

  public create = async (
    payload: Partial<IPhysicalTransship> & { transshipPointIds?: number[] }
  ): Promise<IPhysicalTransship | void> => {
    try {
      const response = await this.api.post(`${this.baseURL}/v1/delivery/physical-transship-point`, {
        name: payload.name,
        initials: payload.initials || null,
        notes: payload.notes || null,
        inUse: payload.inUse !== false,
        transshipPointIds: payload.transshipPointIds ?? [],
      });
      toast.success('Transbordo cadastrado com sucesso!');
      return response;
    } catch (e) {
      toastApiError(e, 'Não foi possível cadastrar o transbordo.');
    }
  };

  public update = async (
    payload: Partial<IPhysicalTransship> & { transshipPointIds?: number[] }
  ): Promise<IPhysicalTransship | void> => {
    if (!payload.id) return;
    try {
      const response = await this.api.put(`${this.baseURL}/v1/delivery/physical-transship-point`, {
        physicalTransshipPointId: payload.id,
        name: payload.name,
        initials: payload.initials,
        notes: payload.notes,
        inUse: payload.inUse,
        transshipPointIds: payload.transshipPointIds ?? [],
      });
      toast.success('Transbordo atualizado com sucesso!');
      return response;
    } catch (e) {
      toastApiError(e, 'Não foi possível atualizar o transbordo.');
    }
  };

}

export const physicalTransshipService = new PhysicalTransshipService(apiService, baseURL);
